import { channels } from '../../../test.data';
import Button from '../../button/v2/button';
import Card from '../../cards/card';
import HeaderInfoCard from '../../cards/v2/info-card/header.info-card';
import { styles } from '../../cards/v2/info-card/styles';
import DetailsContainer from '../../containers/channel/details.container';

type Props = {
  id: string;
  close: Function;
};

export default function DetailsView({ id, close }: Props) {
  const channel = channels.find((c) => c.id === id);

  return (
    <Card className={styles.container}>
      <Card.Header className={styles.header}>
        {channel && (
          <HeaderInfoCard title={channel.title || ''} close={close} />
        )}
      </Card.Header>
      <Card.Body className={styles['alt-body']}>
        {channel && <DetailsContainer id={id} />}
      </Card.Body>
      <Card.Footer className={styles.footer}>
        <Button color="danger" width="full">
          Leave Channel
        </Button>
      </Card.Footer>
    </Card>
  );
}
